/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const t=t=>"mouse"===t.pointerType?"number"!=typeof t.button||t.button<=0:!1!==t.isPrimary;export{t as isPrimaryPointer};
//# sourceMappingURL=is-primary-pointer.js.map
